import {
  IonToolbar,
  IonTitle,
  IonButton,
  IonButtons,
  IonCard,
  IonText,
  IonItem,
  IonLabel,
} from "@ionic/react";
import React, { useRef, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import createArchive from "../../../store/locationShow/actions/createArchive";
import { selectLocation } from "../../../store/locationShow/selectors/selectLocation";
import api from "../../../utils/api";
import axiosInstance from '../../../utils/axiosConfig';

export const PictureSelector: React.FC = () => {
  const location = useSelector(selectLocation);
  const dispatch = useDispatch();
  const fileInput = useRef(null);
  const [imageSrc, setImageSrc] = useState('https://programacion.net/files/article/20161110041116_image-not-found.png');

  useEffect(() => {
    const fetchImage = async () => {
      if (location.picture) {
        try {
          const token = localStorage.getItem('token');
          const response = await fetch(`${api.baseURL}archive/${location.picture.id}`, {
            headers: {
              'Authorization': `Bearer ${token}`,
            },
          });

          if (response.ok) {
            const blob = await response.blob();
            const url = URL.createObjectURL(blob);
            setImageSrc(url);
          } else {
            console.error('Error fetching image:', response.statusText);
          }
        } catch (error) {
          console.error('Fetch error:', error);
        }
      }
    };

    fetchImage();
  }, [location.picture]);

  const onFilechange = async (event: any) => {
    await dispatch(createArchive(event.target.files[0]));
    event.target.value = null;
  };

  return (
    <section>
      <IonItem lines="none">
        <IonLabel>
          <h1 style={{ fontWeight: 500 }}>
            <IonText color="primary">Foto</IonText>
          </h1>
        </IonLabel>
        <IonButton
          slot="end"
          onClick={() => {
            // @ts-ignore
            fileInput?.current?.click();
          }}
        >
          Actualizar
        </IonButton>
      </IonItem>
      <input ref={fileInput} hidden type="file" onChange={onFilechange} />

      <IonCard>
        <img
          src={imageSrc}
          alt="Imagen documento"
          style={{
            height: "298px",
            objectFit: "cover",
            margin: "auto",
            display: "flex",
            background: "white",
          }}
        />
      </IonCard>
    </section>
  );
};